import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
// @ts-check

/** @typedef { import('estree').BaseNode} BaseNode */

/** @typedef {{
	skip: () => void;
	remove: () => void;
	replace: (node: BaseNode) => void;
}} WalkerContext */
export var WalkerBase = /*#__PURE__*/function () {
  function WalkerBase() {
    var _this = this;

    _classCallCheck(this, WalkerBase);

    /** @type {boolean} */
    this.should_skip = false;
    /** @type {boolean} */

    this.should_remove = false;
    /** @type {BaseNode | null} */

    this.replacement = null;
    /** @type {WalkerContext} */

    this.context = {
      skip: function skip() {
        return _this.should_skip = true;
      },
      remove: function remove() {
        return _this.should_remove = true;
      },
      replace: function replace(node) {
        return _this.replacement = node;
      }
    };
  }
  /**
   *
   * @param {any} parent
   * @param {string} prop
   * @param {number} index
   * @param {BaseNode} node
   */


  _createClass(WalkerBase, [{
    key: "replace",
    value: function replace(parent, prop, index, node) {
      if (parent) {
        if (index !== null) {
          parent[prop][index] = node;
        } else {
          parent[prop] = node;
        }
      }
    }
    /**
     *
     * @param {any} parent
     * @param {string} prop
     * @param {number} index
     */

  }, {
    key: "remove",
    value: function remove(parent, prop, index) {
      if (parent) {
        if (index !== null) {
          parent[prop].splice(index, 1);
        } else {
          delete parent[prop];
        }
      }
    }
  }]);

  return WalkerBase;
}();